import mike from "../assets/headshots/mike_p.jpg";
import david from "../assets/headshots/davidt.png";
import allie_p from "../assets/headshots/allie_p.png";
import jacques from "../assets/headshots/jacques.jpeg";

const TeamMembers = [
    {
        id:0,
        img: mike,
        name: "Mike Pasqualicchio",
        pronouns: "He/Him",
        title: "President & Co-Founder",
        role: "President & Co-Founder, Sitting Senior Board Member, Pixel Games Studio",
        skills: "Leadership, Creativity, Writer",
        email: "mikep@boundlessgamers.org",
        fact: "He's obsessed with H.G. Wells' The Time Machine and is writing his own version."
    },
    {
        id:1,
        img: david,
        name: "David Thomas",
        pronouns: "He/Him",
        title: "Senior Board Member",
        role: "Managing Director, Pixel Games Studio | Sitting Senior Board Member, Boundless Gamers",
        skills: "Leadership, Business Management, Game Designer, Negotiations",
        email: "dthomas@boundlessgamers.org",
        fact: ""
    },
    {
        id:2,
        img: jacques,
        name: "Jacques Perkett",
        pronouns: "He/Him",
        title: "Co-Founder",
        role: "Sitting Board Member & Co-Founder, Boundless Gamers",
        skills: "Creativity",
        email: "",
        fact: "He's obsessed with H.G. Wells' The Time Machine and is writing his own version."
    },
];

export default TeamMembers;